import { render, staticRenderFns } from "./CustomCssEditor.vue?vue&type=template&id=4b6fad70&scoped=true"
import script from "./CustomCssEditor.vue?vue&type=script&lang=js"
export * from "./CustomCssEditor.vue?vue&type=script&lang=js"
import style0 from "./CustomCssEditor.vue?vue&type=style&index=0&id=4b6fad70&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b6fad70",
  null
  
)

export default component.exports